import type { ModuleUploadError } from '~/pages/backoffice/admin/modules/module-upload-error'
import { useTranslation } from 'react-i18next'
import { formatBytes } from '~/utils/bytes'

/**
 * Ce qu'on dit d'un envoi de package refusé (#310), dans la langue de
 * l'utilisateur : à l'import d'un module comme au remplacement de son contenu
 * (#311). Le refus de quota donne ses trois chiffres ; les autres refus de
 * l'API gardent son message, qui nomme ce qui manque au package.
 */
export function useDescribeModuleUploadError(): (cause: ModuleUploadError) => string {
  const { t, i18n } = useTranslation()
  return (cause) => {
    switch (cause.kind) {
      case 'quota': return t('storage.uploadRefused', {
        used: formatBytes(cause.usedBytes, i18n.language),
        quota: formatBytes(cause.quotaBytes, i18n.language),
        incoming: formatBytes(cause.incomingBytes, i18n.language),
      })
      case 'tooLarge': return t('modules.upload.tooLarge')
      case 'rejected': return cause.message
      case 'network': return t('modules.upload.network')
      case 'unknown': return t('modules.uploadFailed')
    }
  }
}
